import AssetByTickerSymbol from "pages/br/[tickerSymbol]";

export default AssetByTickerSymbol;
